konnyScript(function($){
    $('[id^=\'rex_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#rex_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#rex_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#rex_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#rex_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#rex_swiper_slide'+index+' .swiper-button-prev';
        var babySlide = new Swiper(this,{
            slidesPerView:1.2,
            slidesPerGroup:1,
            spaceBetween:10,
            centeredSlides:true,
            observer:true,
            observeParents:true,
            loop: false,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                750: {
                    slidesPerView: 4, 
                    spaceBetween: 20,
            		centeredSlides:false,
                },
            },
        });
    });
    
    
    
    $('[id^=\'rex_prd_pc_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#rex_prd_pc_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#rex_prd_pc_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#rex_prd_pc_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#rex_prd_pc_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#rex_prd_pc_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView:'auto',
            slidesPerGroup:1,
            spaceBetween:0,
            centeredSlides:false,
            observer:true,
            observeParents:true,
            loop: false,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
        });
    });

    $('[id^=\'rex_prd_mo_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#rex_prd_mo_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#rex_prd_mo_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#rex_prd_mo_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#rex_prd_mo_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#rex_prd_mo_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            spaceBetween:0,
            centeredSlides:false,
            observer:true,
            observeParents:true,
            loop: false,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
        });
    });

});